import { Badge } from "components/ui";

export function StageDisplay({ stageName, stageId, subStageName }) {
  // Use stageName directly if provided, otherwise fallback to stageId
  const displayName = stageName || (stageId ? `Stage ${stageId}` : 'No Stage');
  const hasSubStage = subStageName && subStageName !== "0" && subStageName !== 0 && subStageName !== "null" && subStageName !== "";
  
  return (
    <div className="flex flex-col gap-1">
      <Badge variant="outline" className="text-xs bg-indigo-50 text-indigo-700 dark:bg-indigo-900/20 dark:text-indigo-400 w-fit">
        {displayName}
      </Badge>
      {hasSubStage && (
        <div className="text-[10px] text-gray-500 dark:text-dark-400 font-medium px-1">
          {subStageName}
        </div>
      )}
    </div>
  );
}
